import { getGameSettings } from "@/game/model/game-settings";

/** Manhattan tiles from player to target foot cell. */
export function combatAttackRange(): number {
  return getGameSettings().combatAttackRange;
}

export function monsterDefaultHp(): number {
  return getGameSettings().monsterDefaultHp;
}
/** Legacy flat damage — use combat-resolve in HomeRoomScene. */
export const COMBAT_HIT_DAMAGE = 12;

/** Reset monster HP if not hit for this long (ms). */
export const MONSTER_HP_IDLE_RESET_MS = 60_000;

/** Dummy combat ratings for attack_dummy targets. */
export const DUMMY_DEFENDER_LEVEL = 1;
